import styled from '@emotion/styled';
import { FC } from 'react';

import ArrowIcon from '@/assets/icons/ic-arrow.svg';

import { FontFamily } from '@/enums/index';
import { ButtonVariant } from '@/styles/themes/button';
import { BREAKPOINTS } from '@/styles/themes/default';

import { FilledButton } from '../core/Button/variants/FilledButton';
import { Heading } from './Common';

const GradientContainer = styled.div<{ color: string }>`
  padding: 56px 20px 100px;
  background: linear-gradient(180deg, ${({ color }) => color} 0%, rgba(182, 255, 226, 0) 100%);

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    padding: 80px 128px 140px;
  }

  p {
    margin: 0;
    margin-bottom: 48px;
    font-family: ${FontFamily.IBMPlexSans};
    font-size: 18px;
    line-height: 135%;

    @media (min-width: ${BREAKPOINTS.Tablet.min}) {
      margin-bottom: 72px;
    }

    @media (min-width: ${BREAKPOINTS.Desktop.min}) {
      font-size: 20px;
      margin-bottom: 58px;
    }
  }
`;

const ActionContainer = styled.div`
  max-width: 722px;
  margin: 0 auto;
  text-align: center;

  ${Heading} {
    margin-bottom: 20px;

    @media (min-width: ${BREAKPOINTS.Tablet.min}) {
      margin-bottom: 36px;
    }

    @media (min-width: ${BREAKPOINTS.Desktop.min}) {
      margin-bottom: 24px;
    }
  }
`;

interface IGradientCallToActionProps {
  onActionClick: () => void;
  color?: string;
  title: string;
  subtitle: string;
  action: string;
}

export const GradientCallToAction: FC<IGradientCallToActionProps> = ({
  onActionClick,
  color = '#aa8af7',
  title,
  subtitle,
  action,
}) => {
  return (
    <GradientContainer color={color}>
      <ActionContainer>
        <Heading>{title}</Heading>
        <p>{subtitle}</p>
        <FilledButton css={{ padding: '16px 24px' }} variant={ButtonVariant.DARK_FILLED} onClick={onActionClick}>
          {action}
          <ArrowIcon css={{ marginLeft: 8 }} />
        </FilledButton>
      </ActionContainer>
    </GradientContainer>
  );
};
